import { AccountLocKey } from '@bonanza-social/account/state';

type Section = {
  headerKey: AccountLocKey;
  textKey: AccountLocKey;
  tableData?: { left: AccountLocKey; right: AccountLocKey }[];
};

const privacyPolicySections: Section[] = [
  { headerKey: 'ourAimHeader', textKey: 'ourAimText' },
  { headerKey: 'dataControllerHeader', textKey: 'dataControllerText' },
  {
    headerKey: 'informationHeader',
    textKey: 'informationWeCollectHeaderText',
  },
  {
    headerKey: 'informationHeader',
    textKey: 'informationWeCollectText',
  },

  {
    headerKey: 'privacySection3Header',
    textKey: 'privacySection3Text',
  },
  {
    headerKey: 'privacySection4Header',
    textKey: 'privacySection4Text',
  },
  {
    headerKey: 'privacySection5Header',
    textKey: 'privacySection5Text',
  },
  {
    headerKey: 'privacySection6Header',
    textKey: 'privacySection6Text',
  },
  {
    headerKey: 'privacySection7Header',
    textKey: 'privacySection7Text',
  },
  {
    headerKey: 'privacySection8Header',
    textKey: 'privacySection8Text',
  },
  {
    headerKey: 'privacySectionAckHeader',
    textKey: 'privacySectionAckText',
  },
];

export default privacyPolicySections;
